// The Undo button on a line in Board activity (agents.tsx): it disables itself while its action runs, and its clicks and
// keys stay on it so the line behind never reacts. Each kind of line keeps only its own action and its tip.

import { useState } from "react";
import { RotateCcw } from "lucide-react";

export function UndoButton({ tip, run }: { tip: string; run: () => Promise<unknown> }) {
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      className="fd-undo"
      disabled={busy}
      data-interactive
      onPointerDown={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation();
        setBusy(true);
        void run().finally(() => setBusy(false));
      }}
      data-tip={tip}
    >
      <RotateCcw size={11} aria-hidden />
      Undo
    </button>
  );
}
